module.exports = __webpack_public_path__ + "static/media/6.74481be2.png";